import { render, staticRenderFns } from "./DisputesHistoryComponent.vue?vue&type=template&id=f9801a42&scoped=true"
import script from "./DisputesHistoryComponent.vue?vue&type=script&lang=js"
export * from "./DisputesHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./DisputesHistoryComponent.vue?vue&type=style&index=0&id=f9801a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9801a42",
  null
  
)

export default component.exports